import React from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  IconButton,
  useMediaQuery,
  Link,
  useTheme,
} from "@mui/material";
import {
  Facebook,
  Twitter,
  LinkedIn,
  YouTube,
  Instagram,
  ArrowForward,
  Email,
  Phone,
  LocationOn,
} from "@mui/icons-material";
import image from "../../src/assets/footer-jik-jak.png";
import { launchingRef } from '../componant/homePage/Home';

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        position: "relative",
        mt: 10,
        fontFamily: "Montserrat, Helvetica, Arial, Lucida, sans-serif",
      }}
    >
      {/* Animated Wave */}
      <Box
        sx={{
          width: "100%",
          height: 20,
          background: `url(${image}) repeat-x`,
          backgroundSize: "contain",
          animation: "moveWave 25s linear infinite",
          position: "absolute",
          top: -20,
          zIndex: 10,
        }}
      />

      {/* Footer Content */}
      <Box
        sx={{
          background: "linear-gradient(to right, #022447, #02203dff)",
          color: "#e0e0e0",
          px: { xs: 4, sm: 6 },
          pt: 10,
          pb: 3,
          position: "relative",
          zIndex: 1,
        }}
      >
        <Grid container spacing={6}>
          {/* FOLLOW US */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                letterSpacing: 2,
                color: "#fff",
                fontFamily: "Montserrat, sans-serif",
              }}
            >
              FOLLOW US
            </Typography>
            <Box sx={{ width: 30, height: 2, bgcolor: "#fff", my: 1 }} />
            <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
              {[
                {
                  Icon: Instagram,
                  url: "https://www.instagram.com/reefindia.official/profilecard/?igsh=ODl3NHNoMGU2Y2o3",
                },
                {
                  Icon: Facebook,
                  url: "https://www.facebook.com/reefindia.official?rdid=LKYNzBVSUtMb3Cul&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F15nXAjbts5%2F",
                },
                {
                  Icon: YouTube,
                  url: "https://www.youtube.com/thehabitatstrust/",
                },
              ].map(({ Icon, url }, index) => (
                <a
                  key={index}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <Box
                    sx={{
                      backgroundColor: "#3e4c52",
                      width: 45,
                      height: 45,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "all 0.3s ease-in-out",
                      cursor: "pointer",
                      "&:hover": {
                        transform: "scale(1.1)",
                        backgroundColor: "#ffffff22",
                      },
                    }}
                  >
                    <Icon sx={{ color: "#fff" }} />
                  </Box>
                </a>
              ))}
            </Box>
          </Grid>

          {/* NAVIGATION */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                letterSpacing: 2,
                color: "#fff",
                fontFamily: "Montserrat, sans-serif",
              }}
            >
              NAVIGATION
            </Typography>
            <Box sx={{ width: 30, height: 2, bgcolor: "#fff", my: 1 }} />
            {["WHO WE ARE", "PROGRAMMES", "CAREERS", "CONTACT"].map(
              (item, i) => (
                <Typography
                  key={i}
                  sx={{
                    my: 1,
                    fontSize: "1rem",
                    letterSpacing: 1,
                    color: "#ffffffcc",
                    fontFamily: "Montserrat, sans-serif",
                    "&:hover": {
                      color: "#fff",
                      cursor: "pointer",
                    },
                  }}
                  onClick={() => {
                    if (item === "WHO WE ARE" && launchingRef.current) {
                      launchingRef.current.scrollIntoView({
                        behavior: "smooth",
                      });
                    }
                  }}
                >
                  {item}
                </Typography>
              )
            )}
          </Grid>

          {/* CONTACT */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                letterSpacing: 2,
                color: "#fff",
                fontFamily: "Montserrat, sans-serif",
              }}
            >
              CONTACT
            </Typography>
            <Box sx={{ width: 30, height: 2, bgcolor: "#fff", my: 1 }} />

            {/* Email */}
            <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
              <Email sx={{ mr: 1, color: "#fff" }} />
              <Link
                href="mailto:reefindia1@gmail.com"
                underline="hover"
                sx={{
                  fontSize: "1rem",
                  color: "#ffffffcc",
                  fontFamily: "Montserrat, sans-serif",
                }}
              >
                reefindia1@gmail.com
              </Link>
            </Box>

            {/* Phone 1 */}
            <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
              <Phone sx={{ mr: 1, color: "#fff" }} />
              <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                <Link
                  href="tel:+919496031796"
                  underline="hover"
                  sx={{
                    fontSize: "1rem",
                    color: "#ffffffcc",
                    fontFamily: "Montserrat, sans-serif",
                  }}
                >
                  +91 94960 31796 /
                </Link>
                <Link
                  href="tel:+919447983004"
                  underline="hover"
                  sx={{
                    fontSize: "1rem",
                    color: "#ffffffcc",
                    fontFamily: "Montserrat, sans-serif",
                    ml: -1,
                  }}
                >
                  94479 83004
                </Link>
              </Box>
            </Box>

            {/* Address */}
            <Box sx={{ display: "flex", alignItems: "flex-start", mt: 2 }}>
              <LocationOn sx={{ mr: 1, color: "#fff", mt: "3px" }} />
              <Typography
                sx={{
                  fontSize: "1rem",
                  color: "#ffffffcc",
                  fontFamily: "Montserrat, sans-serif",
                }}
              >
                Research and Environmental Education Foundation (REEF)
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* SIGN UP */}
        <Box sx={{ mt: 8 }}>
          <Typography
            variant="h6"
            sx={{
              mb: 2,
              fontWeight: 400,
              letterSpacing: 1,
              color: "#fff",
              fontFamily: "Montserrat, sans-serif",
            }}
          >
            SIGN UP FOR UPDATES
          </Typography>

          <Box
            component="form"
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              flexWrap: "wrap",
              alignItems: "center",
              gap: 2,
              maxWidth: "100%",
            }}
          >
            {["FIRST NAME", "LAST NAME", "EMAIL ADDRESS"].map((label, i) => (
              <TextField
                key={i}
                variant="outlined"
                placeholder={label}
                fullWidth={isMobile}
                InputProps={{
                  sx: {
                    borderRadius: 2,
                    fontFamily: "Montserrat, sans-serif",
                    backgroundColor: "#fff",
                    height: 56,
                    minWidth: isMobile
                      ? "100%"
                      : label === "EMAIL ADDRESS"
                      ? 300
                      : 220,
                    px: 2,
                  },
                }}
                inputProps={{
                  style: {
                    fontSize: "0.95rem",
                    letterSpacing: "0.5px",
                    fontFamily: "Montserrat, sans-serif",
                  },
                }}
              />
            ))}
            <IconButton
              sx={{
                backgroundColor: "#2e2e2e",
                color: "#fff",
                width: 56,
                height: 56,
                borderRadius: "50%",
                "&:hover": {
                  backgroundColor: "#1c1c1c",
                },
              }}
            >
              <ArrowForward />
            </IconButton>
          </Box>

          {/* Confirmation Text Placeholder */}
          <Typography sx={{ mt: 2, fontSize: "0.85rem", color: "#90ee90" }}>
            {/* Show this after successful submission */}
            {/* Successfully subscribed! Thank you. */}
          </Typography>
        </Box>

        {/* Bottom Line */}
        <Box
          sx={{
            mt: 6,
            borderTop: "1px solid #ffffff33",
            pt: 2,
            textAlign: "center",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: "0.9rem",
              letterSpacing: 1,
              color: "#ffffffcc",
              fontFamily: "Montserrat, sans-serif",
            }}
          >
            Copyright © 2025 Reef - All Rights Reserved.
          </Typography>
        </Box>
      </Box>

      {/* Keyframes */}
      <style jsx="true">{`
        @keyframes moveWave {
          0% {
            background-position-x: 0;
          }
          100% {
            background-position-x: 1000px;
          }
        }
      `}</style>
    </Box>
  );
};

export default Footer;
